// import { setCookie } from "../src/js/modules/utils";

var currencyIntervalId, currencySwitcherIntervalId;

$(function() {
  // handle change locale
  var loading = false;
  $('.js-nav-locales').click(function(e) {
    e.preventDefault();
    var thisUrl = $(this).attr('href');
    var thisLocale = $(this).data('locale');
    var currentLocale = $('html').attr('lang');
    var defaultLocale = $(this).data('localeprimary');

    var url = '';
    if (currentLocale != thisLocale) {
      if (thisUrl.substring(1, currentLocale.length + 1) == currentLocale) {
        thisUrl = thisUrl.slice(currentLocale.length + 1, thisUrl.length);
        url = '/' + thisLocale + thisUrl;
      } else {
        url = '/' + thisLocale + thisUrl;
      }
    } else {
      url = thisUrl;
    }

    if (defaultLocale && defaultLocale == thisLocale && url.substring(1, defaultLocale.length + 1) == defaultLocale) {
      url = '/' + url.slice(currentLocale.length + 1, url.length);
    }
    window.location.href = url;
  });

  $('.m-nav-locales .locale-name').click(function() {
    if (!$('.m-nav-locales .locale-list').hasClass('active')) {
      $('.m-nav-locales .locale-list').addClass('active');
      loading = true;
      setTimeout(function() {
        loading = false;
      }, 200);
    }
  });

  $('body').on('click', function(e) {
    if ($('.m-nav-locales .locale-list').hasClass('active') && !loading) {
      $('.m-nav-locales .locale-list').removeClass('active');
    }
  });

  // handle link to
  $('.linkTo[data-hover]').hover(
    function() {
      if ($(this).data('hover')) {
        $(this).css({ 'color': $(this).data('hover') , 'transition': 'color .2s' });
      }
    }, function() {
      if ($(this).data('color')) {
        $(this).css({ 'color': $(this).data('color'), 'transition': 'color .2s' });
      } else {
        $(this).css({ 'color': 'inherit', 'transition': 'color .2s' });
      }
    }
  );


  // mobile select nav
  if ($('.m-ContNav--Wrap').length > 0) {
    $('.m-ContNav--Wrap').change(function(e) {
      e.preventDefault();
      var url = $(this).val();
      // console.log(url);
      window.location.href = url;
    });
  }

  // // back btn
  if ($('.js-back-page').length > 0) {
    $('.js-back-page').click(function(e) {
      e.preventDefault();
      var oldURL = document.referrer;
      var url = new URL(oldURL);
      if (url.host == window.location.host) {
        var pathArray = url.pathname.split('/');
        if (pathArray[1] == "collections") {
          window.history.back();
          return;
        }
      }
      window.top.location.href = '/collections/all';
    });

  }

  $("label[for='isGiftCb']").click(function() {
    $('#CartGiftMessage').toggleClass('d-none', $('#isGiftCb').is(':checked'));
  });

  // acount nav
  if ($('.page-accountIndex').length > 0) {
		var this_location = window.location.href;
		var this_location = this_location.split('/');
		var hash = window.location.hash.split('#')[1];
    accountPage(hash);

    $('.pageInnerNav--item, .js-nav-account').click(function(e) {
      if ($(this).attr('id')) {
        e.preventDefault();
        $('.m-hero-menu').removeClass('show');
      } else {
        return ;
      }
      accountPage($(this).attr('id').split('nav-')[1]);
    });
    $('.m-ContNav--Wrap').unbind('change');
    $('.m-ContNav--Wrap').change(function(e) {
      e.preventDefault();
      var url = $(this).val();

      if ($(this).find('[value="'+url+'"]').attr('id')) {
        e.preventDefault();
        accountPage($(this).find('[value="'+url+'"]').attr('id').split('nav-')[1]);
      } else {
        window.location.href = url;
        return ;
      }

    });
  }

  function accountPage(type) {
    $('.page-accountIndex-sub').addClass('d-none');
    $('.pageInnerNav--item[id]').removeClass('on');

    if (type) {
      $('[id="'+type+'"]').removeClass('d-none');
      $('[id="nav-'+type+'"]').addClass('on');
      history.pushState(null, null, '#'+type);

      var selectValue = $('.m-ContNav--Wrap option[id="nav-'+type+'"]').attr('value');
      $('.m-ContNav--Wrap').val(selectValue);
    } else {
      $('[id="home"]').removeClass('d-none');
      $('[id="nav-home"]').addClass('on');
      history.pushState(null, null, '');

      var selectValue = $('.m-ContNav--Wrap option[id="nav-home"]').attr('value');
      $('.m-ContNav--Wrap').val(selectValue);
    }
  }

  // addr edit
  if ($('.js-addr-open').length > 0) {
    $('.js-addr-open').click(function() {
      var addr_id = $(this).data('id');
      $('.addr-qEidt').addClass('d-none');
      $('.addr-qEidt[id="'+addr_id+'"]').removeClass('d-none');
    });

    $('.js-addr-close').click(function() {
      $('.addr-qEidt').addClass('d-none');
    });

    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var target = $el.data('target');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  // collection page
  $(document).on('click', '.js-collection-color', function() {
    var productId = $(this).data('id');
    var color = $(this).data('color');

    $('.js-collection-color[data-id="'+productId+'"]').removeClass('active');
    $(this).addClass('active');

    $('.product--sliderContainer--wrapper[data-id="'+productId+'"], .product--infoWrap h5[data-id="'+productId+'"]').addClass('d-none');
    $('.product--sliderContainer--wrapper[data-id="'+productId+'"][data-color="'+color+'"], .product--infoWrap h5[data-id="'+productId+'"][data-color="'+color+'"]').removeClass('d-none');
    try {
      const targetColor = $('.product--infoWrap h5[data-id="'+productId+'"][data-color="'+color+'"]');
      if (targetColor.length) {
        const varId = targetColor.data('variant-id');
        const parent = $(this).closest('.product--item').find('.product--imageSlider a:not(.swiper-wrapper)');
        if (parent.length) {
          $(parent).each((i, el) => {
            const href = $(el).attr('href').split('?')[0];
            $(el).attr('href', `${href}?variant=${varId}`);
          });
        }
      }

    } catch(e) {
      console.log(e, 'error');
    }
  });

  $(document).ready(function(){
    try {
      $('.product--p-color[show-sale-price="true"] h5:first-child').each((i,e) => {
        if (!$(e).find('.compare-price').length) {
           var a = $(e).closest('.product--p-color').find('.compare-price')[0];
           if (a) {
            var color = $(a).closest('h5').data('color');
            if (color) {
              $(e).closest('.product--p-color').find(`.js-collection-color[data-color="${color}"]`).click()
            }
           }
        }
      })
    } catch(e) {
      console.log('error');
    }

    if (window.innerWidth <= 991) {
      $('.embed-responsive-video--desktop').remove();
    } else {
      $('.embed-responsive-video--mobile').remove();
    }

    // video = document.querySelector('.embed-responsive-video--mobile');
    // window.clickedVideo = 0;
    // if (window.innerWidth <= 991) {
    //   $('.video-link-to').click(function (evt) {
    //     if (video && video.paused) {
    //       evt.preventDefault();
    //       video.play();
    //       window.clickedVideo += 1;
    //     } else if (window.clickedVideo < 1) {
    //       window.clickedVideo += 2;
    //       evt.preventDefault();
    //     }
    //   });
    // }
  });

  // save pid so page goes back to same product upon clicking back
  $(document).on('click','.page-collection .product--item a',function(e){
    var elem = $(this);
    var pid = elem.closest('.product--item').data('pid');
    if (pid) {
      window.location.hash = pid;
    }
    return true;
  });

  // product page
  if ($('.productInfo').length > 0) {
    if ($('.coloritem[checked]').length > 0) {
      var color = $('.coloritem[checked]').attr('value');
      prodPageSilder();
      ProductDetailsHandleSectionH();
    } else {
      $('.productimg-loop').removeClass('d-none');
    }

    const madeToOrderText = $('.productInfo--shipping-time').parent().data('made-to-order');
    const shippingText = $('.productInfo--shipping-time').parent().data('shipping');
    const engravingOptionsSelector = '.engrave--input input[type="text"]';
    if ($(engravingOptionsSelector).length > 0) {
      $(engravingOptionsSelector).on('input', function() {
        $('.productInfo--shipping-time').text(shippingText);
        $(engravingOptionsSelector).each(function() {
          if ($(this).val()) {
            $('.productInfo--shipping-time').text(madeToOrderText);
            return false;
          }
        });
      });
    }

    const engraveV2Option = $('.engraving-v2-design select');
    const engraveV2Zodiac = $('.engraving-v2-zodiac');
    const engraveV2ZodiacSelect = $('.engraving-v2-zodiac select');
    const engraveV2ZodiacPreview = $('.engraving-v2-zodiac-preview');
    const engraveV2Text = $('.engraving-v2-text');
    const engraveV2TextInput = $('.engraving-v2-text input');
    $(engraveV2Option).on('change', function() {
      if ($(this).val() === 'zodiac') {
        $(engraveV2Zodiac).removeClass('d-none');
      } else {
        $(engraveV2Zodiac).addClass('d-none');
        $(engraveV2ZodiacSelect).val('').trigger('change');
      }
      if ($(this).val() === 'text') {
        $(engraveV2Text).removeClass('d-none');
      } else {
        $(engraveV2Text).addClass('d-none');
        $(engraveV2TextInput).val('');
      }
    });

    $(engraveV2ZodiacSelect).on('change', function() {
      engraveV2ZodiacPreview.removeClass('aries taurus gemini cancer leo virgo libra scorpio sagittarius capricorn aquarius pisces');
      engraveV2ZodiacPreview.addClass($(this).val());
    });
  }

  // nav change currency
  if ($('.js-change-currency').length > 0) {
    $('.js-change-currency').click(function(e) {
      e.preventDefault();
      var currency = $(this).data('iso');
      $('.js-currency-form [name="currency"]').val(currency);
      $('.js-currency-form').submit();
    });
  }
  $('.shopify-currency-form select').on('change', function() {
    $(this).parents('form').submit();
  });

  // modal function
  if ($('.info-C').length > 0) {
    $('.info-C').click(function(e) {
      e.stopPropagation();
      $($(this).data('target')).modal('show')
    });

  }
});


var currency_json = {"BD": "BDT", "BE": "EUR", "BF": "XOF", "BG": "BGN", "BA": "BAM", "BB": "BBD", "WF": "XPF", "BL": "EUR", "BM": "BMD", "BN": "BND", "BO": "BOB", "BH": "BHD", "BI": "BIF", "BJ": "XOF", "BT": "BTN", "JM": "JMD", "BV": "NOK", "BW": "BWP", "WS": "WST", "BQ": "USD", "BR": "BRL", "BS": "BSD", "JE": "GBP", "BY": "BYR", "BZ": "BZD", "RU": "RUB", "RW": "RWF", "RS": "RSD", "TL": "USD", "RE": "EUR", "TM": "TMT", "TJ": "TJS", "RO": "RON", "TK": "NZD", "GW": "XOF", "GU": "USD", "GT": "GTQ", "GS": "GBP", "GR": "EUR", "GQ": "XAF", "GP": "EUR", "JP": "JPY", "GY": "GYD", "GG": "GBP", "GF": "EUR", "GE": "GEL", "GD": "XCD", "GB": "GBP", "GA": "XAF", "SV": "USD", "GN": "GNF", "GM": "GMD", "GL": "DKK", "GI": "GIP", "GH": "GHS", "OM": "OMR", "TN": "TND", "JO": "JOD", "HR": "HRK", "HT": "HTG", "HU": "HUF", "HK": "HKD", "HN": "HNL", "HM": "AUD", "VE": "VEF", "PR": "USD", "PS": "ILS", "PW": "USD", "PT": "EUR", "SJ": "NOK", "PY": "PYG", "IQ": "IQD", "PA": "PAB", "PF": "XPF", "PG": "PGK", "PE": "PEN", "PK": "PKR", "PH": "PHP", "PN": "NZD", "PL": "PLN", "PM": "EUR", "ZM": "ZMK", "EH": "MAD", "EE": "EUR", "EG": "EGP", "ZA": "ZAR", "EC": "USD", "IT": "EUR", "VN": "VND", "SB": "SBD", "ET": "ETB", "SO": "SOS", "ZW": "ZWL", "SA": "SAR", "ES": "EUR", "ER": "ERN", "ME": "EUR", "MD": "MDL", "MG": "MGA", "MF": "EUR", "MA": "MAD", "MC": "EUR", "UZ": "UZS", "MM": "MMK", "ML": "XOF", "MO": "MOP", "MN": "MNT", "MH": "USD", "MK": "MKD", "MU": "MUR", "MT": "EUR", "MW": "MWK", "MV": "MVR", "MQ": "EUR", "MP": "USD", "MS": "XCD", "MR": "MRO", "IM": "GBP", "UG": "UGX", "TZ": "TZS", "MY": "MYR", "MX": "MXN", "IL": "ILS", "FR": "EUR", "IO": "USD", "SH": "SHP", "FI": "EUR", "FJ": "FJD", "FK": "FKP", "FM": "USD", "FO": "DKK", "NI": "NIO", "NL": "EUR", "NO": "NOK", "NA": "NAD", "VU": "VUV", "NC": "XPF", "NE": "XOF", "NF": "AUD", "NG": "NGN", "NZ": "NZD", "NP": "NPR", "NR": "AUD", "NU": "NZD", "CK": "NZD", "XK": "EUR", "CI": "XOF", "CH": "CHF", "CO": "COP", "CN": "CNY", "CM": "XAF", "CL": "CLP", "CC": "AUD", "CA": "CAD", "CG": "XAF", "CF": "XAF", "CD": "CDF", "CZ": "CZK", "CY": "EUR", "CX": "AUD", "CR": "CRC", "CW": "ANG", "CV": "CVE", "CU": "CUP", "SZ": "SZL", "SY": "SYP", "SX": "ANG", "KG": "KGS", "KE": "KES", "SS": "SSP", "SR": "SRD", "KI": "AUD", "KH": "KHR", "KN": "XCD", "KM": "KMF", "ST": "STD", "SK": "EUR", "KR": "KRW", "SI": "EUR", "KP": "KPW", "KW": "KWD", "SN": "XOF", "SM": "EUR", "SL": "SLL", "SC": "SCR", "KZ": "KZT", "KY": "KYD", "SG": "SGD", "SE": "SEK", "SD": "SDG", "DO": "DOP", "DM": "XCD", "DJ": "DJF", "DK": "DKK", "VG": "USD", "DE": "EUR", "YE": "YER", "DZ": "DZD", "US": "USD", "UY": "UYU", "YT": "EUR", "UM": "USD", "LB": "LBP", "LC": "XCD", "LA": "LAK", "TV": "AUD", "TW": "TWD", "TT": "TTD", "TR": "TRY", "LK": "LKR", "LI": "CHF", "LV": "EUR", "TO": "TOP", "LT": "LTL", "LU": "EUR", "LR": "LRD", "LS": "LSL", "TH": "THB", "TF": "EUR", "TG": "XOF", "TD": "XAF", "TC": "USD", "LY": "LYD", "VA": "EUR", "VC": "XCD", "AE": "AED", "AD": "EUR", "AG": "XCD", "AF": "AFN", "AI": "XCD", "VI": "USD", "IS": "ISK", "IR": "IRR", "AM": "AMD", "AL": "ALL", "AO": "AOA", "AQ": "", "AS": "USD", "AR": "ARS", "AU": "AUD", "AT": "EUR", "AW": "AWG", "IN": "INR", "AX": "EUR", "AZ": "AZN", "IE": "EUR", "ID": "IDR", "UA": "UAH", "QA": "QAR", "MZ": "MZN"};

const rate = Shopify.currency.rate
const shippingThreshold = {
    hk: {
        usd: 0,
        hkd: 0,
    },
    sg: {
        usd: 100,
        hkd: 100 * rate,
    },
    us: {
        usd: 100,
        hkd: 100 * rate
    },
    au: {
        usd: 100,
        hkd: 100 * rate
    },
    gb: {
        usd: 150,
        hkd: 150 * rate
    },
    fr: {
        usd: 150,
        hkd: 150 * rate
    },
    res: {
        usd: 200,
        hkd: 200 * rate
    }
}

const shippingRates = {
  hk: {
      usd: 0,
      hkd: 0,
  },
  sg: {
      usd: 10,
      hkd: 10 * rate,
  },
  us: {
      usd: 10,
      hkd: 10 * rate
  },
  au: {
      usd: 10,
      hkd: 10 * rate
  },
  gb: {
      usd: 10,
      hkd: 10 * rate
  },
  fr: {
      usd: 10,
      hkd: 10 * rate
  },
  res: {
      usd: 10,
      hkd: 10 * rate
  }
}


function getShippingThreshold(country) {
  if (country === undefined) {
    return 200;
  }
  country = shippingThreshold[country.toLowerCase()] ? country.toLowerCase() : null;
  return (country in shippingThreshold ? shippingThreshold[country] && shippingThreshold[country][Shopify.currency.active.toLowerCase()] : 200);
}

function getShippingRate(country) {
  if (country === undefined) {
    return 10;
  }
  country = shippingRates[country.toLowerCase()] ? country.toLowerCase() : null;
  return (country in shippingRates ? shippingRates[country] && shippingRates[country][Shopify.currency.active.toLowerCase()] : 10);
}

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/; domain=."+window.location.hostname;
}

var observeDOM = (function(){
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function( obj, callback ){
    if( !obj || obj.nodeType !== 1 ) return;

    if( MutationObserver ){
      // define a new observer
      var mutationObserver = new MutationObserver(callback)

      // have the observer observe foo for changes in children
      mutationObserver.observe( obj, { childList:true, subtree:true })
      return mutationObserver
    }

    // browser support fallback
    else if( window.addEventListener ){
      obj.addEventListener('DOMNodeInserted', callback, false)
      obj.addEventListener('DOMNodeRemoved', callback, false)
    }
  }
})()

function setCurrencyByCountry(country) {
  let mappedCurrency = currency_json[country]
  if (mappedCurrency) {
    var promoText = "Free shipping on orders over ";
    var pdpShippingText = "";

    if (country == "HK") {
      promoText = 'Free Shipping on all orders to Hong Kong';
      pdpShippingText = 'Free Shipping to Hong Kong';
      $('.topbar-content-middle .global').remove();
      $('.topbar-content-middle .hk').removeClass('d-none');
      $('.left-global-hk').removeClass('d-none');
    } else if (country) {
      $('.left-global').removeClass('d-none');
      promoText += 'US$' + getShippingThreshold(country);
      pdpShippingText = 'Free Shipping on orders over US$' + getShippingThreshold(country);
      $('.topbar-content-middle .hk').remove();
      $('.topbar-content-middle .global').removeClass('d-none');
    }
  }
}

function checkLocalization(country) {
  if (country === 'AU' && window.themeSettings.localization !== 'AUD' && getCookie('manualUpdate') !== 'true') {
    $("#localization-top [name='country_code']").val('AU').trigger('change');
    window.location.href = window.location.href.replace('en-us', '');
  } else if (country === 'SG' && window.themeSettings.localization !== 'SGD' && getCookie('manualUpdate') !== 'true') {
    $("#localization-top [name='country_code']").val('SG').trigger('change');
    window.location.href = window.location.href.replace('en-us', '');
  } else if (country === 'HK' && window.themeSettings.localization !== 'HKD' && getCookie('manualUpdate') !== 'true') {
    $("#localization-top [name='country_code']").val('HK').trigger('change');
    window.location.href = window.location.href.replace('en-us', '');
  } else if (country !== 'HK' && country !== 'SG' && country !== 'AU' && window.themeSettings.localization !== 'USD' && getCookie('manualUpdate') !== 'true') {
    $("#localization-top [name='country_code']").val('US').trigger('change');

    // $('#local_country_code').val('HK');
    // $('#local_country_code').parent().submit();
  }
}

const calcDiscount = (el) => {
  const originalEl = el.querySelector('.tdf_price_original .tdf_money');
  const salesEl = el.querySelector('.tdf_price_sales .tdf_money');
  const oldCopyEl = document.querySelectorAll('#tdf_sale_widget .sale_widget_copy');
  if (oldCopyEl.length) {
    oldCopyEl.forEach((e) => { e.remove(); });
  }
  if (originalEl && salesEl) {
    const originalPrice = parseInt(originalEl.dataset.originValue, 10);
    const salesPrice = parseInt(salesEl.dataset.originValue, 10);
    const percent = 100 - Math.round(salesPrice * 100 / originalPrice);

    const copyEl = el.cloneNode(true);
    copyEl.className = 'sale_widget_copy'
    copyEl.querySelector('br').className = '';
    copyEl.querySelector('.tdf_price_original').remove();
    copyEl.querySelector('.tdf_product_title').remove();
    copyEl.querySelector('.tdf_money').remove();
    copyEl.querySelector('.tdf_price_sales').textContent = `${percent}% OFF`;
    el.after(copyEl);

    console.log('originalPrice', originalPrice);
    console.log('salesPrice', salesPrice);
    console.log('percent', 100 - Math.round(salesPrice * 100 / originalPrice));
  }
}
const discountObserver = () => {
  const inverval = setInterval(() => {
    const el = document.querySelector('#tdf_sale_widget .tdf_nonpopup');
    console.log(el);
    if (el) {
      clearInterval(inverval);
      calcDiscount(el);
      observeDOM(el, function (m) {
        calcDiscount(el);
      })
    }
  }, 500);
}
if ($('body').hasClass('locale-fr')) {
  discountObserver();
}

const countrySuggestionModal = (country) => {
  const updatedLocale = getCookie('updatedLocalization') || 'US';
  const locale = getCookie('localization');
  // const shown = getCookie('showSuggestedCurrency');
  // if (shown === 'true') return;
  document.getElementById('locale-country').value = country;
  if (country === updatedLocale) return;

  if (window.location.hostname.includes('nyssajewellery.com') || window.location.hostname.includes('nyrelle.com')) {
    createCookie('updatedLocalization', country);
    document.getElementById('localization-form').submit();
  };

  // const modalEl = $('#countrySuggestion');
  // const selectEl = modalEl.find('select');

  // const currencyDetectedEl = selectEl.find(`[value=${country}]`);
  // const currencyNowEl = selectEl.find(`[value=${localization || 'US'}]`);

  // const detected = currencyDetectedEl.length > 0 ? currencyDetectedEl.data('currency') : 'USD';
  // const now = currencyNowEl.length > 0 ? currencyNowEl.data('currency') : 'USD';
  // currencyDetectedEl.prop('selected', 'selected');
  // if (detected === now) return;

  // modalEl.modal('show');
  // createCookie('showSuggestedCurrency', 'true');
}

$(function() {
  if (!window.location.hostname.includes('nyrelle.com')) return;
  const country = getCookie('detectedCountryCode');
  const localization = getCookie('updatedLocalization') || getCookie('localization');
  if (country) {
    setCurrencyByCountry(country);
    checkLocalization(country);
    if (document.getElementById('locale-country')) {
      countrySuggestionModal(country);
    }
  } else {
    $.getJSON('https://api.ipgeolocation.io/ipgeo?apiKey=c296c20793584f448fc3a66fd772e462', function(location) {
      if (location && location.country_code2) {
        createCookie('detectedCountryCode', location.country_code2, 1);
        setCurrencyByCountry(location.country_code2);
        if (document.getElementById('locale-country')) {
          countrySuggestionModal(country);
        }
        checkLocalization(location.country_code2);
      }
    })
    .fail(function() {
      setCurrencyByCountry(localization);
      createCookie('detectedCountryCode', localization, 1);
    });
  }
});

// pdp functions
$(function() {
  $('.product--fair_pricing .retail-price').each(function() {
    let currentVariant = $(this);
    let retail_price = currentVariant.data('money');

  if (retail_price && Shopify.currency.rate) {

      let price = Math.ceil(retail_price * Shopify.currency.rate);
      currentVariant.html( '<span class="money">' +
      Shopify.formatMoney(
        (price * 100),
        '${{amount_no_decimals}}'
      ) + ' ' + Shopify.currency.active + '</span>');
    }
  });

  freeShippingBar();

  let currentDiscount = null;
  setInterval(function(){
      if (currentDiscount !== sessionStorage.getItem("currentDiscount")) {
          currentDiscount = sessionStorage.getItem("currentDiscount");
          freeShippingBar({ keepDiscount: true });
      }
  }, 500);


  function getAddOnSelectedVariant(parentElem) {
    try {
      var availableVariants = JSON.parse(parentElem.find('.pdp-addon-variants-json').html());
      var selectedOptions = parentElem.find('form select, form input[type=radio]').serializeArray();
      selectedOptions = selectedOptions.filter(x => x.name.indexOf('properties') !== 0);


      var found = _.find(availableVariants, function(variant) {
        return selectedOptions.every(function(option) {
          return _.isEqual(variant[option.name.replace(/.*_option/, "option")], option.value);
        });
      });

      return found;
    } catch (e) {}
    return null;
  }

  $('.pdp-addon-product select, .pdp-addon-product input[type=radio]').change(function() {
    var parentElem = $(this).closest('.pdp-addon-product');
    var selectedVariant = getAddOnSelectedVariant(parentElem);
    if (selectedVariant) {
      let retail_price = selectedVariant.price;
      if (retail_price) {
        let newMoneyElement = $('<div class="money" data-regular-price></div>');
        newMoneyElement.html(Shopify.formatMoney(retail_price,'${{amount}}') + ' ' + Shopify.currency.active);
        parentElem.find('div.money').replaceWith(newMoneyElement);
      }
    }
  });

  $('.pdp-addon-product input[name=addoncb]').on('click', function(e) {
    const id = $(this).attr('id');
    const checked = $(this).is(':checked');
    if (id == 'addon2' && checked && !$('#addon1').is(':checked')) {
      $('#addon1').prop('checked', true);
      $('#addon1').trigger('change');
      return false;
    }
    if (id == 'addon1' && !checked && $('#addon2').is(':checked')) {
      $('#addon2').prop('checked', false);
      $('#addon2').trigger('change');
      return false;
    }
  });

  $('.pdp-addon-product input[name=addoncb]').change(function() {
    var parentElem = $(this).closest('.pdp-addon-product');
    if (parentElem.find('.cbWrapper.collapsable').length > 0) {
      if ($(this).is(':checked')) {
        parentElem.find('.addonHeader').addClass('d-none');
        parentElem.find('form').removeClass('d-none');
      } else {
        parentElem.find('.addonHeader').removeClass('d-none');
        parentElem.find('form').addClass('d-none');
      }
    }

    var numAddOnItems = $('.pdp-addon-product input[name=addoncb]:checked').length + 1;
    if (numAddOnItems > 1) {
      $('[data-add-to-cart-text]').text('Add ' + numAddOnItems + ' items to cart');
    } else {
      $('[data-add-to-cart-text]').text('Add to cart');
    }
  });

  jQuery.fn.extend({
    getAddOnSelectedVariant: function() {
      var parentElem = $(this).closest('.pdp-addon-product');
      var selectedVariant = getAddOnSelectedVariant(parentElem);
      if (selectedVariant) {
        var data = {};
        parentElem.find('form').serializeArray().map(
          function(x){
            data[x.name] = x.value;
          });
        data['id'] = selectedVariant.id;
        return data;
      }
      return null;
    }
  })

})

function freeShippingBar(input) {
  if (!input) {
    input = { subtotal: 0 };
  }

  if (input.subtotal) {
    $('.cart-total-price').val(input.subtotal);
  }

  var price_in_cents = $('.cart-total-price').val();
  var country = getCookie('detectedCountryCode');
  var threshold = getShippingThreshold(country);
  $('.cart--fsc').removeClass('d-none');

  if (price_in_cents <= 0) {
    $('.cart--fsc').addClass('d-none');
    return;
  }

  var shipping_price = getShippingRate(country);
  let price = price_in_cents / 100;
  if (price >= threshold) {
    shipping_price = 0;
  }

  if (shipping_price <= 0) {
    $('.cart--fsc .less-than-200').parent().removeClass('d-none');
    $('.cart--fsc .more-than-200').removeClass('d-none');
    $('.cart--fsc .less-than-200').addClass('d-none');
    $('.cart--fsc .progress, .cart--fsc .progress-bar').removeClass('d-none').css({ width: '100%' });
    $('[data-cart-shipping]').html('<span data-shipping-price="0">Free</span>');
  } else {
    $('.cart--fsc .less-than-200').parent().removeClass('d-none');
    $('.cart--fsc .more-than-200').addClass('d-none');
    $('.cart--fsc .less-than-200').removeClass('d-none');
    $('.cart--fsc .progress-bar, .cart--fsc .progress').removeClass('d-none');
    $('.cart--fsc .progress-bar').css({ width: (price / threshold * 100)+'%' });
    setTimeout(function() {
      $('.cart--fsc .less-than-200').html('You\'re <span class="money">'+ theme.Currency.formatMoney((threshold - price) * 100, theme.moneyFormatWithCurrencyNoHtml)+'</span> away from free shipping');
      $('[data-cart-shipping]').html('<span data-shipping-price="'+ shipping_price +'">'+ theme.Currency.formatMoney(shipping_price * 100, theme.moneyFormatWithCurrencyNoHtml) + '</span>');
    }, 200);
  }

  let currentDiscount = (i = sessionStorage.getItem("currentDiscount")) ? i : null;
  let discountAmount = 0;
  if (currentDiscount) {
      let discount = JSON.parse(currentDiscount);
      if (!input.keepDiscount) {
        $('[data-cart-discount]').html('<span class="dcloading" style="opacity: 1; \
          border: 2px solid #5c5c5c; border-bottom: 2px solid rgba(255,255,255,0.0); \
          border-left: 2px solid rgba(255,255,255,0.0); left: auto;">\
          </span>');
        $('#dcodeInput').val(discount.title);
        $('#dcodeSubmit').click();
        return;
      }

      $('.cart--discount-label').html('Discount (<b>' + discount.title + '</b>)');
      discountAmount = Math.round(discount.value * 100) * 0.01;
      $('[data-cart-discount]').html('<span>-'+ theme.Currency.formatMoney(discountAmount * 100) + '</span>');
      $('.cart--discount').removeClass('d-none');
      $('.cart--discount').addClass('d-flex');
  } else {
      $('.cart--discount').addClass('d-none');
      $('.cart--discount').removeClass('d-flex');
  }

  let total_price = price + shipping_price - discountAmount;

  if (typeof theme.Currency === 'object') {
    setTimeout(function(){
      $('[data-cart-subtotal]').html('<span>'+ theme.Currency.formatMoney(price_in_cents, theme.moneyFormatWithCurrency) + '</span>');
      $('[data-cart-total]').html('<span>'+ theme.Currency.formatMoney(total_price * 100, theme.moneyFormatWithCurrency) + '</span>');
    }, 100);
  }

  // shoppingBag();
  updateMoney();
}

function updateMoney() {
  (function() {
    $('.money, span.amount').each((index, element) => {
      newText = $(element).text().replace('.00', '');
      $(element).text(newText);
    });
  })();
}

if (window.template === 'product' && window.product) {
  if ($('.pdp-upsell').length) {
    $.ajax(`/products/${window.product.handle}?sections=upsell`).then((res) => {
      const parser = new DOMParser();
      const newDom = parser.parseFromString(res.upsell, 'text/html');
      const contentUpsell = newDom.querySelector('#shopify-section-upsell .upsell').innerHTML;
      $('.pdp-upsell').html(contentUpsell);

      new Swiper('.upsell-swipper', {
        autoHeight: false, //enable auto height
        loop: $('.upsell-swipper .swiper-slide').length > 3,
        spaceBetween: 15,
        speed: 800,
        slidesPerView: 3,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      if (!$('.upsell-swipper .swiper-slide').length) {
        $('.pdp-upsell').remove();
      }
      if ($('.upsell-swipper .swiper-slide').length < 3) {
        $(".upsell__title .section--right").hide();
      }
    });
  } else if ($('.pdp-upsell-metafields').length) {
    new Swiper('.upsell-swipper', {
      autoHeight: false, //enable auto height
      loop: $('.upsell-swipper .swiper-slide').length > 3,
      spaceBetween: 15,
      speed: 800,
      slidesPerView: 3,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    if ($('.upsell-swipper .swiper-slide').length <= 3) {
      $(".upsell__title .section--right").hide();
    }
  }
}